// Mobile on-screen-keyboard auto-collapse for the activity dock.
// Originally inlined in `ActivityFloatingDock`; extracted as a sibling
// hook to keep that file under the file-size soft cap as more
// workflow-facilitation behavior (peek lifecycle, assist-level wiring)
// lands. No behavior change vs. the previous inline implementation.
//
// Phase 4 of docs/planning/org_activity_floating_dock.md §12: when the
// iOS / Android software keyboard opens it shrinks
// `visualViewport.height` substantially. If the dock panel happens to
// be open over a focused input it would block the input — so we
// auto-close the panel while leaving the tab visible. We do NOT
// auto-re-open when the keyboard closes; that's left to the user.

import { useEffect } from "react";
import { detectKeyboardOpen } from "./useActivityDockPosition";

export function useActivityDockKeyboardCollapse(
  closePanel: () => void,
): void {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const v = window.visualViewport;
    if (!v) return;
    function onResize() {
      if (!v) return;
      if (detectKeyboardOpen(window.innerHeight, v.height)) {
        closePanel();
      }
    }
    v.addEventListener("resize", onResize);
    return () => v.removeEventListener("resize", onResize);
  }, [closePanel]);
}
